// Axios
import axios from "axios";

// Toast
import { toast } from 'react-toastify';

// Alert Dialog
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

// Helpers
import Helpers from ".";

// Config
import Config from '../config';

const createShoppingCart = async (values: any) => {
    try {
        const response = await axios.post(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.shoppingCart}`,
            {
                data: {
                    ...values,
                }
            },
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        if (response.data.status) {
            toast(Helpers.translation(response.data.message))
        } else {
            confirmAlert({
                title: Helpers.translation('error'),
                message: Helpers.translation(response.data.message),
                buttons: [
                    {
                        label: Helpers.translation('i-got-it'),
                    }
                ]
            });
        }

        return response.data;
    } catch (error) {
        console.log('createShoppingCart:', error);
    }
}

const updateShoppingCart = async (shoppingCartId: number, values: any, toastStatus: boolean = true) => {
    try {
        const response = await axios.put(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.shoppingCart}/${shoppingCartId}`,
            {
                data: {
                    ...values,
                }
            },
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        if (response.data.status === true) {
            if (toastStatus) {
                toast(Helpers.translation(response.data.message));
            }
        } else {
            let message = Helpers.translation(response.data.message);

            if (response.data.status === "stock-error") {
                message = Helpers.translationParams(response.data.message, response.data.messageParams)
            }

            confirmAlert({
                title: Helpers.translation('error'),
                message,
                buttons: [
                    {
                        label: Helpers.translation('i-got-it'),
                    }
                ]
            });
        }
    } catch (error) {
        console.log('updateShoppingCart:', error);
    }
}

const deleteShoppingCart = async (shoppingCartId: number) => {
    try {
        confirmAlert({
            title: Helpers.translation('warning'),
            message: Helpers.translation('delete-alert-text'),
            buttons: [
                {
                    label: Helpers.translation('yes'),
                    onClick: async () => {
                        const response = await axios.delete(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.shoppingCart}/${shoppingCartId}`,
                            {
                                headers: {
                                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                                }
                            }
                        );

                        if (response.data.status) {
                            toast(Helpers.translation(response.data.message));
                        } else {
                            confirmAlert({
                                title: Helpers.translation('error'),
                                message: Helpers.translation(response.data.message),
                                buttons: [
                                    {
                                        label: Helpers.translation('i-got-it'),
                                    }
                                ]
                            });
                        }
                    }
                },
                {
                    label: Helpers.translation('no'),
                }
            ]
        });
    } catch (error) {
        console.log('deleteShoppingCart:', error);
    }
};

const exportHelpers = {
    createShoppingCart,
    updateShoppingCart,
    deleteShoppingCart
}

export default exportHelpers;